<template>
  <Screen center-transparent>
    <div
      slot="screen-center"
      class="home"
    >
      <section class="home__content">
        <h1 class="home__heading">
          Hello there 👋
        </h1>
        <p class="home__text">
          Fashion is very important. It is life-enhancing and, like everything
          that gives pleasure, it is worth doing well.
        </p>
        <router-link to="projects">
          <ElButton type="primary">
            Start
          </ElButton>
        </router-link>
      </section>
    </div>
    <Version />
  </Screen>
</template>

<script>
import Screen from '@/components/Screen.vue'
// TODO: remove it after they have their own route (#699)
import Version from '@/components/utility/Version'

export default {
  name: 'Home',

  components: {
    Screen,
    Version
  }
}
</script>

<style lang="scss" scoped>
$max-width-home-text: 390px;

.home {
  height: 100%;
}

.home__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: $spacer-unit;
}

.home__heading {
  font-size: $font-size-extra-large;
}

.home__text {
  max-width: $max-width-home-text;
  text-align: center;
}
</style>
